import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1aeb736f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "free-shipping text-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Free Shipping on US orders over $500 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("a", null, [
      _createVNode(_component_fa, {
        icon: "truck",
        style: {"width":"20px","height":"20px"}
      }),
      _hoisted_2
    ])
  ]))
}